<template lang="pug">
  .component-backoffice-vehicle-hardware(v-if="item")
    .card.card-section(v-if="$is('hardware-card')")
      .row
        .columns
          span Hardware Information
        .columns.shrink
          dropdown(:icon="'fa fa-ellipsis-v fa-lg'", :position="'top'")
            vehicle-hardware-action-buttons(:item="item", @update="update")
      .row
        .columns
          h3 #VH{{item.id}}
          span Manifacturer
          h3 {{item.manager | manager}}
          span Serial
          h3 {{item.serial}}
    .one-look(v-if="$is('oneLook')")
      span Hardware Serial
      span {{item.serial}}
    .card( v-if="$is('listing')")
      .inner-content
        card3
          .field-vehicle-hardware(slot="n1")
            .field-value VH-{{item.id}}
            .field-value Serial {{item.serial}}
          .field-vehicle-serial(slot="n2")
            .field-label Manager
            .field-value
              strong {{item.manager | manager}}
</template>
<script type="text/babel">
  import Dropdown from "components/structure/foundation/Dropdown";
  import Card3 from "../structure/Card3";
  import VehicleHardwareActionButtons from "../structure/ui/actions/VehicleHardwareActionButtons";

  export default {
    name: "VehicleHardware",
    components: {
      VehicleHardwareActionButtons,
      Card3,
      Dropdown,
    },
    data() {
      return {}
    },
    created() {
    },
    methods: {
      update() {
        this.$emit('update')
      }
    },
    props: {
      item: Object,
      type: {
        type: String,
        default: ''
      }
    },
    filters: {
      manager(value) {
        return value.replace(/App\\Logic\\VehicleHardware\\/, '')
      }
    },
  }
</script>
<style lang="sass" rel="stylesheet/sass">
</style>



// WEBPACK FOOTER //
// VehicleHardware.vue?a994c06e